// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__rj_6S","inputDescription":"styles_inputDescription__3fPTr"};